<template>
  <v-hover v-slot="{ isHovering, props }">
    <div
      v-if="location"
      class="location"
      :class="{'location-hover': isHovering}"
      v-bind="props"
      @click="onLocationClick"
    >
      <LocationIcon
        :fill="isHovering ? '#e18d3d' : '#aaaaaa'"
      />
      <p
        class="location-text"
        :class="{'location-hover-text': isHovering}"
      >
        {{ text }}
      </p>
    </div>
  </v-hover>
</template>

<script>
import LocationIcon from '../svgs/MenuIcons/LocationIcon.vue';
import {MapService} from '@/services/MapService';

const round = (n) => n.toFixed(5);

export default {
  name: 'InfoWindowCoordinates',
  components: {
    LocationIcon,
  },
  props: {
    location: {
      type: Object,
      default: undefined,
    },
  },
  computed: {
    lat() {
      return this.location?.lat?.() ?? 0;
    },
    lng() {
      return this.location?.lng?.() ?? 0;
    },
    text() {
      return [this.lat, this.lng].map(round).join(', ');
    },
  },
  methods: {
    async onLocationClick() {
      const zoom = MapService.getMap().getZoom() > 15 ? MapService.getMap().getZoom() : 15;
      await MapService.centerViewport({lat: this.lat, lng: this.lng}, zoom);
    },
  },
};
</script>

<style lang="scss" scoped>

.location {
  display: flex;
  align-items: center;
  gap: 5px;

  &-text {
    font-size: 13px;
    color: rgb(170, 170, 170);
    white-space: nowrap;
    cursor: text;
  }
  &-hover {
    cursor: pointer;
  }
  &-hover-text {
    color: main.$npOrange;
    text-decoration: underline;
  }
}

</style>
